import { useState, useEffect, useContext } from 'react';
import { AppConfigContext } from '../context';

export interface FutarchyData {
    date: string;
    total_trades: number;
    total_volume: number;
    unique_accounts: number;
    passPrice: number;
    failPrice: number;
}

export const useFutarchyData = () => {
    const { apiUrl } = useContext(AppConfigContext);
    const [futarchyData, setFutarchyData] = useState<FutarchyData | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    const fetchFutarchyData = async () => {
        setIsLoading(true);
        setError(null);
        try {
            const response = await fetch(`${apiUrl}/kyros/futarchy`);
            if (!response.ok) {
                // If endpoint doesn't exist yet, return null
                if (response.status === 404) {
                    setFutarchyData(null);
                    setIsLoading(false);
                    return;
                }
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data: FutarchyData = await response.json();
            if (data) {
                setFutarchyData(data);
            }
        } catch (err) {
            console.error("Error fetching futarchy data:", err);
            setFutarchyData(null);
            setError("Error fetching futarchy data");
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchFutarchyData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { futarchyData, isLoading, error, refetch: fetchFutarchyData };
};
